import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  showUpdate,
  remove,
  getList,
  copiarTrocasControladores,
  getControladorList,
  removeTrocaPlanoControlador,
  createUpdateTrocaPlanoControlador,
  updateTrocaPlanoControlador,
  updateTrocaPlanoControladorGeral,
  setPaginaAtual,
  getPlanosVinculados,
} from './trocaPlanoActions';
import SPButton from '../common/form/spButton';
import { toastr } from 'react-redux-toastr';
import { getConfig } from '../configuracao/configLocal';
import html2canvas from 'html2canvas';

import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import ButtonTooltip from '../common/form/buttonTooltip';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import ProcessingOverlay from '../common/components/processingOverlay';
import If from '../common/operator/if';
import PermissaoUsuario from '../auth/permissao';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

class TrocaPlanoList extends Component {
  constructor(props) {
    super(props);

    this.copiarDadosControladores = this.copiarDadosControladores.bind(this);
    this.lerTrocaPlanoControlador = this.lerTrocaPlanoControlador.bind(this);
    this.salvarControladorDB = this.salvarControladorDB.bind(this);
    this.lerTrocaPlanoSistema = this.lerTrocaPlanoSistema.bind(this);
    this.salvarTrocaPlanoControlador = this.salvarTrocaPlanoControlador.bind(this);
    this.confirmarExclusao = this.confirmarExclusao.bind(this);
    this.cancelarExclusao = this.cancelarExclusao.bind(this);
    this.confirmarEnviarControlador = this.confirmarEnviarControlador.bind(this);
    this.cancelarEnviarControlador = this.cancelarEnviarControlador.bind(this);
    this.confirmarEnviarTodos = this.confirmarEnviarTodos.bind(this);
    this.cancelarEnviarTodos = this.cancelarEnviarTodos.bind(this);
    this.confirmarSalvarSistema = this.confirmarSalvarSistema.bind(this);
    this.cancelarSalvarSistema = this.cancelarSalvarSistema.bind(this);

    this.componentRef = React.createRef();

    this.state = {
      salvarDB: false,
      confirmExclusao: null,
      confirmEnviarControlador: false,
      confirmEnviarTodos: false,
      confirmSalvarSistema: null,
      processingGeral: false,
      processingMessage: '',
      processingDetail: '',
    };
  }

  startProcessing(message, detail = '') {
    this.setState({
      processingGeral: true,
      processingMessage: message,
      processingDetail: detail,
    });
  }

  stopProcessing(extraState = {}) {
    this.setState({
      processingGeral: false,
      processingMessage: '',
      processingDetail: '',
      ...extraState,
    });
  }

  renderDiaCell(value) {
    const ativo = parseInt(value, 10) === 1;
    return (
      <span className={`troca-plano-dia-badge ${ativo ? 'is-sim' : 'is-nao'}`}>{ativo ? 'Sim' : 'Não'}</span>
    );
  }

  sortByHorario(list) {
    return [...list].sort((a, b) => {
      const horaA = (a.horario_inicial || '').slice(0, 8);
      const horaB = (b.horario_inicial || '').slice(0, 8);
      return horaA.localeCompare(horaB);
    });
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  // Método para capturar todas as páginas da tabela de forma invisível
  captureAllPages = async () => {
    const data = this.props.list || [];
    const pageSize = 15; // Tamanho da página definido no ReactTableGT2A
    const totalPages = Math.ceil(data.length / pageSize);
    const images = [];

    try {
      // Capturar cada página silenciosamente
      for (let page = 0; page < totalPages; page++) {
        // Navegar para a página silenciosamente
        this.props.setPaginaAtual(page);

        // Aguardar a renderização (tempo reduzido)
        await sleep(400);

        // Capturar a imagem da página atual
        const canvas = await html2canvas(this.componentRef.current, {
          useCORS: true,
          scale: 0.8, // Reduzir escala para performance
          logging: false,
          allowTaint: true,
        });
        const image = canvas.toDataURL('image/png', 0.7);
        images.push(image);
      }

      // Sempre voltar para a página 1 (índice 0)
      this.props.setPaginaAtual(0);
      await sleep(200);

      return images;
    } catch (error) {
      console.error('Erro ao capturar páginas:', error);
      // Em caso de erro, captura apenas a página atual
      const canvas = await html2canvas(this.componentRef.current);
      const image = canvas.toDataURL('png');

      // Voltar para página 1
      this.props.setPaginaAtual(0);

      return [image];
    }
  };

  copiarDadosControladores() {
    this.setState({ confirmEnviarTodos: true });
  }

  cancelarEnviarTodos() {
    this.setState({ confirmEnviarTodos: false });
  }

  confirmarEnviarTodos() {
    this.setState({ confirmEnviarTodos: false });
    const data = this.props.list || [];
    this.startProcessing(
      'Enviando tabelas de troca para os controladores...',
      'Replicando configurações do grupo físico.',
    );

    this.props
      .copiarTrocasControladores()
      .then(result => {
        if (!result.error) {
          this.props
            .updateTrocaPlanoControladorGeral(data)
            .then(result2 => {
              this.stopProcessing();
              if (result2.error) {
                toastr.warning('Atenção', result2.payload.response.data || 'Falha ao atualizar controladores');
              } else {
                toastr.success('Sucesso', 'Operação realizada com sucesso.');
              }
            })
            .catch(e2 => {
              this.stopProcessing();
              toastr.warning(
                'Atenção',
                e2.response && e2.response.data && e2.response.data.errors
                  ? e2.response.data.errors.join('<br />')
                  : 'Falha ao atualizar controladores',
              );
            });
        } else {
          this.stopProcessing();
          toastr.warning('Atenção', result.payload.response.data || 'Falha ao realizar a cópia dos dados');
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.warning(
          'Atenção',
          e.response && e.response.data && e.response.data.errors
            ? e.response.data.errors.join('<br />')
            : 'Falha ao realizar a cópia dos dados',
        );
      });
  }

  lerTrocaPlanoControlador() {
    this.startProcessing('Lendo tabelas do controlador...', 'Comunicando com a central e o equipamento.');

    this.props
      .getControladorList()
      .then(result => {
        this.stopProcessing();

        if (result.error) {
          toastr.error('Erro', result.payload.response.data.errors[0]);
          this.props.getList();
        } else {
          toastr.success('Sucesso', 'Operação realizada com sucesso.');
          this.setState({ salvarDB: true });
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.error('Erro', e.response.data.errors[0]);
        this.props.getList(getConfig('cont'), this.props['data-plano']);
      });
  }

  lerTrocaPlanoSistema() {
    this.props.getList();
    this.setState({ salvarDB: false });
  }

  salvarControladorDB() {
    const data = (this.props.list || []).map(item => ({ ...item }));
    let valido = true;

    for (let index = 0; index < data.length; index++) {
      if (!data[index].valido) {
        toastr.error('Atenção', `Cadastre o plano ${data[index].plano_id} em Planos do Controlador`);
        valido = false;
        break;
      }
      delete data[index].valido;
    }

    if (!valido) {
      return;
    }

    this.setState({ confirmSalvarSistema: { data } });
  }

  cancelarSalvarSistema() {
    this.setState({ confirmSalvarSistema: null });
  }

  confirmarSalvarSistema() {
    const { confirmSalvarSistema } = this.state;
    if (!confirmSalvarSistema) return;

    const { data } = confirmSalvarSistema;
    this.setState({ confirmSalvarSistema: null });
    this.startProcessing('Salvando tabelas no sistema...', 'Substituindo os dados atuais pelos lidos do controlador.');

    if (data.length === 0) {
      this.stopProcessing({ salvarDB: false });
      return;
    }

    this.props
      .removeTrocaPlanoControlador()
      .then(async result => {
        if (result.error) {
          this.stopProcessing();
          toastr.error('Erro', result.payload.response.data.errors[0]);
        } else {
          const savePromises = data.map(item => this.props.createUpdateTrocaPlanoControlador(item));
          await Promise.all(savePromises);
          this.props.getList();
          this.stopProcessing({ salvarDB: false });
          toastr.success('Sucesso', 'Dados do controlador salvos no sistema.');
        }
      })
      .catch(e => {
        this.stopProcessing();
        toastr.error('Erro', e.message || 'Erro ao salvar no sistema');
      });
  }

  validaDiasTrocaPlano(data) {
    let semana = {
      dom: false,
      seg: false,
      ter: false,
      qua: false,
      qui: false,
      sex: false,
      sab: false,
    };

    let diasSemPlano = '';

    for (const key in data) {
      if (!semana.dom && parseInt(data[key].domingo) === 1) {
        semana.dom = true;
      }
      if (!semana.seg && parseInt(data[key].segunda) === 1) {
        semana.seg = true;
      }
      if (!semana.ter && parseInt(data[key].terca) === 1) {
        semana.ter = true;
      }
      if (!semana.qua && parseInt(data[key].quarta) === 1) {
        semana.qua = true;
      }
      if (!semana.qui && parseInt(data[key].quinta) === 1) {
        semana.qui = true;
      }
      if (!semana.sex && parseInt(data[key].sexta) === 1) {
        semana.sex = true;
      }
      if (!semana.sab && parseInt(data[key].sabado) === 1) {
        semana.sab = true;
      }
    }

    if (!semana.dom) {
      diasSemPlano += '"Domingo", ';
    }
    if (!semana.seg) {
      diasSemPlano += '"Segunda", ';
    }
    if (!semana.ter) {
      diasSemPlano += '"Terça", ';
    }
    if (!semana.qua) {
      diasSemPlano += '"Quarta", ';
    }
    if (!semana.qui) {
      diasSemPlano += '"Quinta", ';
    }
    if (!semana.sex) {
      diasSemPlano += '"Sexta", ';
    }
    if (!semana.sab) {
      diasSemPlano += '"Sábado", ';
    }
    return diasSemPlano;
  }

  salvarTrocaPlanoControlador() {
    this.setState({ confirmEnviarControlador: true });
  }

  cancelarEnviarControlador() {
    this.setState({ confirmEnviarControlador: false });
  }

  async confirmarEnviarControlador() {
    this.setState({ confirmEnviarControlador: false });
    const data = this.props.list || [];
    const diasSemPlano = this.validaDiasTrocaPlano(data);

    if (diasSemPlano) {
      toastr.warning('Alerta', `O(s) dia(s) da semana: ${diasSemPlano} não tem plano cadastrado.`);
      return;
    }

    this.startProcessing('Enviando tabelas ao controlador...', 'Aguarde, este processo pode levar algum tempo.');

    try {
      const images = await this.captureAllPages();
      const pageSize = 15;
      const dataWithImage = data.map((item, index) => {
        const pageIndex = Math.floor(index / pageSize);
        const imageLogData = {
          currentPageImage: images[pageIndex] || images[0],
          allImages: images,
          pageNumber: pageIndex + 1,
          totalPages: images.length,
          itemIndex: index,
        };

        return {
          ...item,
          imageLog: JSON.stringify(imageLogData),
        };
      });

      const result = await this.props.updateTrocaPlanoControlador(dataWithImage);
      this.stopProcessing();

      if (result.error) {
        toastr.error('Erro', result.payload.response.data.errors[0]);
      } else {
        toastr.success('Sucesso', 'Trocas de Plano enviadas com sucesso.');
      }
    } catch (error) {
      console.error('Erro ao enviar tabelas:', error);
      try {
        const result = await this.props.updateTrocaPlanoControlador(data);
        this.stopProcessing();
        if (result.error) {
          toastr.error('Erro', result.payload.response.data.errors[0]);
        } else {
          toastr.success('Sucesso', 'Trocas de Plano enviadas com sucesso.');
        }
      } catch (e) {
        this.stopProcessing();
        toastr.error('Erro', e.response.data.errors[0]);
      }
    }
  }

  async removerTrocaPlano(data) {
    if (data.id > 0) {
      try {
        const controladorId = getConfig('cont');
        const resultPlanosVinculados = await this.props.getPlanosVinculados(data.id, controladorId);
        const planosVinculados = resultPlanosVinculados.payload.data || [];

        if (planosVinculados.length > 0) {
          const planosInfo = planosVinculados.map(p => `${p.plano_id} (${p.plano_descricao})`).join(', ');
          this.setState({
            confirmExclusao: {
              data,
              comPlanos: true,
              planosInfo,
            },
          });
        } else {
          this.setState({
            confirmExclusao: {
              data,
              comPlanos: false,
            },
          });
        }
      } catch (error) {
        console.error('Erro ao verificar planos vinculados:', error);
        this.setState({
          confirmExclusao: {
            data,
            comPlanos: false,
          },
        });
      }
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido exclusão ou alteração sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  confirmarExclusao() {
    const { confirmExclusao } = this.state;
    if (!confirmExclusao) return;
    this.props.remove(confirmExclusao.data);
    this.setState({ confirmExclusao: null });
  }

  cancelarExclusao() {
    this.setState({ confirmExclusao: null });
  }

  alterarTrocaPlano(data) {
    if (data.id > 0) {
      this.props.showUpdate(data);
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido exclusão ou alteração sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  render() {
    const trocaPlano = this.sortByHorario(this.props.list || []);
    const paginaAtual = this.props.paginaAtual;
    const {
      confirmExclusao,
      confirmEnviarControlador,
      confirmEnviarTodos,
      confirmSalvarSistema,
      processingGeral,
      processingMessage,
      processingDetail,
    } = this.state;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="troca-plano-actions-cell">
            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <div className="troca-plano-actions-group">
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.alterarTrocaPlano(row.original)}
                />
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir"
                  onClick={() => this.removerTrocaPlano(row.original)}
                />
              </div>
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <div className="troca-plano-actions-group">
                <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
                <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
              </div>
            </PermissaoUsuario>
          </div>
        ),
        width: 104,
        filterable: false,
        className: 'column_icon',
      },
      {
        Header: 'Plano',
        accessor: 'plano_tratado',
        width: 120,
        className: 'column_grid column_center',
        filterable: false,
      },
      {
        Header: 'Dom',
        accessor: 'domingo',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Seg',
        accessor: 'segunda',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Ter',
        accessor: 'terca',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Qua',
        accessor: 'quarta',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Qui',
        accessor: 'quinta',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Sex',
        accessor: 'sexta',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Sab',
        accessor: 'sabado',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => this.renderDiaCell(value),
      },
      {
        Header: 'Horário',
        accessor: 'horario_inicial',
        className: 'column_grid column_center',
        width: 220,
        filterable: false,
      },
    ];

    return (
      <div ref={this.componentRef}>
        <ProcessingOverlay
          show={processingGeral}
          message={
            processingMessage ? (
              <>
                {processingMessage}
                {processingDetail ? <small>{processingDetail}</small> : null}
              </>
            ) : (
              'Aguarde…'
            )
          }
          tagline="Tabela de Troca de Plano"
        />
        <ActionConfirmModal
          show={!!confirmExclusao}
          title={
            confirmExclusao && confirmExclusao.comPlanos
              ? 'Tabela de Troca vinculada a Plano'
              : 'Deseja realmente excluir?'
          }
          message={
            confirmExclusao && confirmExclusao.comPlanos
              ? `Essa tabela de troca está vinculada ao(s) plano(s) ${confirmExclusao.planosInfo}. Deseja continuar com a exclusão?`
              : 'A tabela de troca será removida permanentemente do sistema.'
          }
          itemName={
            confirmExclusao && confirmExclusao.data
              ? confirmExclusao.data.plano_tratado || `Tabela ${confirmExclusao.data.id}`
              : ''
          }
          itemDetail={
            confirmExclusao && confirmExclusao.data
              ? `Horário ${confirmExclusao.data.horario_inicial || '—'}`
              : ''
          }
          confirmLabel={confirmExclusao && confirmExclusao.comPlanos ? 'Sim, excluir' : 'Excluir'}
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusao}
          onCancel={this.cancelarExclusao}
        />
        <ActionConfirmModal
          show={confirmEnviarControlador}
          title="Enviar tabelas de troca para o controlador?"
          message="Essa ação vai substituir as configurações existentes no controlador."
          itemName={`${trocaPlano.length} tabela(s) de troca`}
          itemDetail="Controlador selecionado"
          confirmLabel="Enviar"
          icon="upload"
          onConfirm={this.confirmarEnviarControlador}
          onCancel={this.cancelarEnviarControlador}
        />
        <ActionConfirmModal
          show={confirmEnviarTodos}
          title="Enviar para todos os controladores do grupo físico?"
          message="Essa ação vai substituir as configurações existentes nos controladores do mesmo grupo físico."
          itemName={`${trocaPlano.length} tabela(s) de troca`}
          itemDetail="Grupo físico do controlador"
          confirmLabel="Enviar para todos"
          icon="copy"
          onConfirm={this.confirmarEnviarTodos}
          onCancel={this.cancelarEnviarTodos}
        />
        <ActionConfirmModal
          show={!!confirmSalvarSistema}
          title="Substituir os dados atuais do sistema?"
          message="Os dados lidos do controlador substituirão as tabelas de troca cadastradas no sistema."
          itemName={
            confirmSalvarSistema ? `${confirmSalvarSistema.data.length} tabela(s) lida(s) do controlador` : ''
          }
          itemDetail="Dados atuais do sistema serão removidos"
          confirmLabel="Sim, salvar"
          icon="save"
          onConfirm={this.confirmarSalvarSistema}
          onCancel={this.cancelarSalvarSistema}
        />
        <style>{`
          .troca-plano-actions-cell {
            display: flex;
            justify-content: center;
            width: 100%;
          }

          .troca-plano-actions-group {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 2px;
          }

          .troca-plano-actions-group .btn {
            border-radius: 9px !important;
            min-width: 28px;
            width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 0 !important;
            box-shadow: none !important;
            padding: 0 !important;
            font-size: 12px !important;
          }

          .troca-plano-actions-group .btn.warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
            color: #ffffff !important;
          }

          .troca-plano-actions-group .btn.danger {
            background: linear-gradient(135deg, #f87171 0%, #ef4444 100%) !important;
            color: #ffffff !important;
          }

          .troca-plano-footer {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            flex-wrap: wrap;
            padding-top: 12px;
          }

          .troca-plano-footer-left {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
          }

          .troca-plano-footer-right {
            margin-left: auto;
          }

          .troca-plano-footer .btn {
            border-radius: 12px !important;
            min-height: 40px;
            padding: 0 16px !important;
            border: 0 !important;
            font-weight: 600;
            box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08) !important;
          }

          .troca-plano-footer .btn.success {
            background: linear-gradient(135deg, #5fa8d3 0%, #3d8ec3 100%) !important;
            color: #ffffff !important;
          }

          .troca-plano-footer .btn.primary {
            background: linear-gradient(135deg, #4f8fb8 0%, #2f6f98 100%) !important;
            color: #ffffff !important;
          }

          .troca-plano-footer .btn.warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
            color: #ffffff !important;
          }

          .troca-plano-premium-table .ReactTable .rt-th.column_grid,
          .troca-plano-premium-table .ReactTable .rt-td.column_grid {
            justify-content: flex-start;
            text-align: left;
          }

          .troca-plano-premium-table .ReactTable .rt-th.column_center,
          .troca-plano-premium-table .ReactTable .rt-td.column_center,
          .troca-plano-premium-table .ReactTable .rt-th.column_icon,
          .troca-plano-premium-table .ReactTable .rt-td.column_icon {
            justify-content: center;
            text-align: center;
          }

          .troca-plano-dia-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 34px;
            padding: 2px 8px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.02em;
          }

          .troca-plano-dia-badge.is-sim {
            background: rgba(34, 197, 94, 0.14);
            color: #15803d;
          }

          .troca-plano-dia-badge.is-nao {
            background: rgba(239, 68, 68, 0.12);
            color: #b91c1c;
          }
        `}</style>
        <div className="troca-plano-premium-table">
          <PremiumTableShell summary={`${trocaPlano.length} tabela(s) carregada(s)`} tableMinWidth={1000}>
            <ReactTableGT2A
              data={trocaPlano}
              columns={columns}
              showFilters={false}
              className="-striped -highlight"
              defaultPageSize={15}
              minRows={0}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
            />
          </PremiumTableShell>
        </div>
        <div className="troca-plano-footer">
          <div className="troca-plano-footer-left">
            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataLerControlador"
                className="success"
                icon="download"
                label="Ler do Controlador"
                data-title="Busca os dados do controlador"
                onClick={this.lerTrocaPlanoControlador}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <ButtonTooltip type="button" className="success" icon="download" label="Ler do Controlador" disabled />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataEnviarControlador"
                className="primary"
                icon="upload"
                label="Enviar para esse Controlador"
                data-title="Envia os dados para o controlador"
                onClick={this.salvarTrocaPlanoControlador}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                className="primary"
                icon="upload"
                label="Enviar para esse Controlador"
                disabled
              />
            </PermissaoUsuario>

            <If condicao={this.state.salvarDB}>
              <>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    id="btnDataTrocaPlanoSalvarDB"
                    className="primary"
                    icon="check"
                    label="Salvar no sistema"
                    data-title="Salva no sistema os dados que vieram do controlado"
                    onClick={this.salvarControladorDB}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
                  <ButtonTooltip type="button" className="primary" icon="check" label="Salvar no sistema" disabled />
                </PermissaoUsuario>
              </>
            </If>

            <If condicao={this.state.salvarDB}>
              <>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    id="btnTrocaPlanoLerSistema"
                    className="primary"
                    icon="file-download"
                    label="Ler do sistema"
                    data-title="Busca os dados do banco de dados do sistema"
                    onClick={this.lerTrocaPlanoSistema}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
                  <ButtonTooltip
                    type="button"
                    className="primary"
                    icon="file-download"
                    label="Ler do sistema"
                    disabled
                  />
                </PermissaoUsuario>
              </>
            </If>
          </div>

          <div className="troca-plano-footer-right">
            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataReplicarTrocaPlano"
                className="warning"
                icon="copy"
                label="Enviar para Todos os Controladores"
                data-title="Replica a troca de plano para os controladores do grupo físico"
                onClick={this.copiarDadosControladores}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                className="warning"
                icon="copy"
                label="Enviar para Todos os Controladores"
                disabled
              />
            </PermissaoUsuario>
          </div>
        </div>
      </div>
    );
  }
}
// busca o planoCad la do reducers.js
const mapStateToProps = state => ({
  list: state.trocaPlanoCad.list,
  paginaAtual: state.trocaPlanoCad.paginaAtual,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showUpdate,
      remove,
      getList,
      copiarTrocasControladores,
      getControladorList,
      removeTrocaPlanoControlador,
      createUpdateTrocaPlanoControlador,
      updateTrocaPlanoControlador,
      updateTrocaPlanoControladorGeral,
      setPaginaAtual,
      getPlanosVinculados,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrocaPlanoList);
